import * as React from "react";
import _ from "lodash";
import { Dimmer } from "semantic-ui-react";
import Table from "../../components/Table/Table";
import EditKCEProduct from "../../containers/Editing/EditKCEProduct";
import EditKCEVersion from "../../containers/Editing/EditKCEVersion";
import { editActions } from "../../actions/editActions";
import { Filter } from "../../components/Table/Migration/LegacyTypes";

export type VPProps = {
  columns: State.ColumnMap;
  rows: Api.AnyVP[];
  mainState: State.Main;
  editedObjectId: number | undefined;
  isEditActive: boolean;
  editActions: typeof editActions;
  subMenuRoute: State.KCEVPSubmenu;
  toggleModal: () => void;
  columnFilters?: Filter[];
  setColumnFilters: (subMenuRoute: State.KCEVPSubmenu, columnFilter: Filter[]) => void;
};

export class VersionAndProduct extends React.Component<VPProps> {

  componentDidMount(): void {
    // make throttle function
    this.handleFilterChangeDebounced = _.debounce(this.handleFilterChangeDebounced, 500);
  }

  private handleFilterChangeDebounced = (changedFilters: Filter[]) => {
    this.props.setColumnFilters(this.props.subMenuRoute, changedFilters);
  };

  render(): JSX.Element {
    const { columns, mainState, subMenuRoute, isEditActive, rows } = this.props;
    const { editSize, pageSize, isShortenTextEnabled } = mainState;

    const selectedColumns: State.Column[] = columns[subMenuRoute];

    return (
      <div className="table-container">
        <div className="flex-1">
          <div className="flex-1">
            <Table
              rows={rows}
              columns={selectedColumns}
              isHidingTextActive={isShortenTextEnabled}
              handleRowSelection={this.props.editActions.select}
              isRowSelected={this.isSelected}
              pageSize={pageSize}
              handleFilterChange={this.handleFilterChangeDebounced}
              />
          </div>
          {isEditActive && (
            <Dimmer active={true} page={true}>
              <div className="edit-view" style={{ flex: editSize , width : editSize == 0.3 ? "500px" : "1000px" }}>
                {subMenuRoute === "Products" ? (
                  <EditKCEProduct toggleModal={this.props.toggleModal} />
                ) : (
                  <EditKCEVersion toggleModal={this.props.toggleModal} />
                )}
              </div>
            </Dimmer>
          )}
        </div>
      </div>
    );
  }

  private isSelected = (vp: Api.AnyVP): boolean => {
    const { editedObjectId } = this.props;
    if (editedObjectId && vp.id === editedObjectId) {
      return true;
    } else {
      return false;
    }
  };
}

export default VersionAndProduct;
